<div class="w-full h-full flex flex-col gap-4 p-6 max-w-7xl mx-auto">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <h2 class="text-2xl font-bold">{{ packet.packetName }}</h2>
    <button mat-dialog-close>
      <img src="assets/icons/close.svg" alt="Close" />
    </button>
  </div>

  @if (isLoading()) {
  <!-- Loading spinner -->
  <div class="flex-1 flex justify-center items-center">
    <et-atoms-spinner size="large"></et-atoms-spinner>
  </div>
  } @else {
  <!-- Dashboard -->
  <et-journal-dashboard class="flex-1"></et-journal-dashboard>
  }
</div>
